<template>
    <q-breadcrumbs active-color="black" separator="" gutter="none" > 
      <q-breadcrumbs-el v-for="filter in filters" :key="filter.label">
          <q-btn flat dense class="q-pa-xs">
            {{filter.type}}
            <q-btn icon="clear" flat color="primary" dense @click.native="e => removeFilter(e, filter)" size="sm"/>
            <product-filter-popup :filterType="filter.type"></product-filter-popup>
          </q-btn>
      </q-breadcrumbs-el>
        <q-btn flat dense icon="add" label="Add Filter"  v-if="!allFiltersAreShowing">
          <product-filter-popup></product-filter-popup>
        </q-btn>
        <q-btn flat dense v-if="filters.length" icon="clear" color="primary" class="q-px-xs" @click="clearFilters">Clear All</q-btn>
    </q-breadcrumbs>
</template>

<script>
import ProductFilterPopup from './ProductFilterPopup'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductFilters',
  components: { ProductFilterPopup },
  computed: {
    ...mapGetters('filters', ['colourGroups']),
    filters () {
      return this.$store.state.filters.filters
    },
    /**
     * Returns true if we have every type of filter showing.
     * You can only have one of each type of filter.
     * @returns {boolean}
     */
    allFiltersAreShowing () {
      return this.$store.state.filters.filters.length >= this.$store.state.filters.filterTypes.length
    }
  },
  methods: {
    removeFilter (event, filter) {
      event.preventDefault()
      this.$store.commit('filters/removeFilter', filter)
      analytics.track('Remove Filter', {
        storeType: this.$store.state.cart.currentStoreType,
        filter: filter
      })      
    },
    clearFilters () {
      this.$q.dialog({
        title: 'Clear Filters',
        message: 'Would you like to clear all filters including the search box?',
        cancel: 'No',
        ok: 'Yes'
      }).onOk(() => {
        this.$store.commit('filters/clearFilters')
        analytics.track('Remove All Filters', {
          storeType: this.$store.state.cart.currentStoreType,
        })  
      })
    },
    makeFilterColourLabel (filterValues) {
      // Get all unique values
      const groups = [...new Set(filterValues.map(v => v.group))]
      // Map sub colours under each group
      const all = groups.map(group => {
        let colours = filterValues.filter(v => v.group === group)
        return {
          hex: colours[0].hex,
          name: group,
          colours
        }
      })

      return all.reduce((prev, curr) => {
        const fullGroup = this.colourGroups.find(group => group.name === curr.name)
        const allSelected = fullGroup?.colours?.every((colour) => {
          // Check if this colour is in the selected colours
          return !!curr.colours.find(c => c.name === colour.name)
        })
        const colourNames = allSelected ? 'all' : curr.colours.reduce((p, c) => `${p}${p.length ? ', ' : ''}${c.name}`, '')
        return `${prev}${prev.length ? ', ' : ''} ${curr.name} (${colourNames})`
      }, '')
    },
    makeFilterLabel (filter) {
      let inner = ''
      if (filter.type === 'brand') {
        inner = filter.values
      } else if (filter.type === 'price') {
        inner = '$' + filter.values.min + '-$' + filter.values.max
      } else if (filter.type === 'material') {
        inner = filter.values
      } else if (filter.type === 'colour') {
        inner = this.makeFilterColourLabel(filter.values)
      } else if (filter.type === 'size') {
        inner = filter.values
      } else if (filter.type === 'grip') {
        inner = filter.values
      } else if (filter.type === 'type') {
        inner = filter.values
      }
      let typeCapitialised = filter.type.charAt(0).toUpperCase() + filter.type.slice(1)
      return `${typeCapitialised}: ${inner}`
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~quasar-variables'
  .q-btn{
    @media (max-width: 1024px) {
      font-size:10px
    }
  }
   .q-btn{
    @media (max-width: 920px) {
      font-size:12px
    }
  }




</style>
